import { Component } from 'react';
// import classNames from 'classnames';

import {
  timeFormat,
  dateFormat,
  dateFormatNoTimeZone
} from 'common/helpers/dateHelper';
import { currencyFormat } from 'common/helpers/numberHelper';
import LoginToPurchase from 'reservations/availability/LoginToPurchase';

import ExperienceImage from './ExperienceImage';
import Price from './Price';

class Experience extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: props.experience.options[0]
    };
  }

  handleCreateReservation = (e) => {
    e.preventDefault();
    const { props } = this;
    const { experience } = this.props;
    const { selectedOption } = this.state;
    const reservationDate = e.currentTarget.getAttribute('data-time');
    const clickProperties = {
      reservationType: experience.title,
      sku: selectedOption.sku,
      price: selectedOption.price
    };
    props.onCreateReservation(
      reservationDate,
      experience.id,
      selectedOption.id,
      clickProperties
    );
  };

  handleOptionChange = (e) => {
    const { props } = this;
    const selectedOption = props.experience.options.find(
      (option) => option.id === e.target.value
    );
    this.setState({ selectedOption });
  };

  handleSearch = (e) => {
    const { props } = this;
    e.preventDefault();
    const reservationDate = e.currentTarget.getAttribute('data-date');
    props.onSearch({
      reservationDate,
      reservationTime: props.reservationTime,
      guestCount: props.guestCount,
      reservationTypeId: props.reservationTypeId
    });
  };

  render() {
    const { experience, settings, reservationDate } = this.props;
    const { selectedOption } = this.state;
    let requiresLogin = false;
    if (
      experience.security &&
      experience.security.availableTo !== 'Public' &&
      !experience.security.isValidUser
    ) {
      requiresLogin = true;
    }

    return (
      <div className="c7-experience">
        <div className="c7-experience__image">
          <ExperienceImage experience={experience} />
        </div>
        <div className="c7-experience__content">
          <h2>{experience.title}</h2>
          <Price variant={selectedOption} settings={settings} />
          <div dangerouslySetInnerHTML={{ __html: experience.content }} />

          {experience.times.length > 0 && (
            <OptionArray
              options={experience.options}
              selectedOption={selectedOption}
              handleOptionChange={this.handleOptionChange}
              settings={settings}
            />
          )}

          {experience.times.length === 0 && (
            <div className="c7-product__variant__add-to-cart">
              No available times for {dateFormatNoTimeZone(reservationDate)}
              <br />
              <br />
            </div>
          )}
          {experience.nextAvailableDates &&
            experience.nextAvailableDates.length > 0 && (
              <>
                Next available date
                <br />
                {experience.nextAvailableDates.map((date) => (
                  <button
                    className="c7-button-alt"
                    type="submit"
                    key={date}
                    onClick={this.handleSearch}
                    data-date={dateFormat(date, settings, 'isoDate')}
                  >
                    {dateFormat(date, settings)}
                  </button>
                ))}
              </>
            )}
          {requiresLogin && <LoginToPurchase reservationType={experience} />}
          {!requiresLogin && experience.times.length > 0 && (
            <form
              action=""
              className="c7-form c7-product__variant"
              method="post"
            >
              <div className="c7-product__variant__add-to-cart">
                Available times for {dateFormatNoTimeZone(reservationDate)}
                <br />
                {experience.times.map((time) => (
                  <button
                    className={
                      time.isRequestedTime ? 'c7-button' : 'c7-button-alt'
                    }
                    type="submit"
                    key={time.time}
                    onClick={this.handleCreateReservation}
                    data-time={time.time}
                  >
                    Reserve {timeFormat(time.time, settings)}
                  </button>
                ))}
              </div>
            </form>
          )}
        </div>
      </div>
    );
  }
}

const OptionArray = (props) => {
  const { options, selectedOption, handleOptionChange, settings } = props;
  if (options.length === 1) {
    return null;
  }
  return (
    <label htmlFor="c7-reservation-option">
      Options for this experience
      <br />
      <select
        className="c7-product__variant__select"
        name="optionId"
        id="c7-reservation-option"
        value={selectedOption.id}
        onChange={handleOptionChange}
      >
        {options.map((option) => (
          <option key={option.id} value={option.id}>
            {option.title} {currencyFormat(option.addToCartPrice, settings)}
          </option>
        ))}
      </select>
    </label>
  );
};

export default Experience;
